export enum ERROR {
    NOT_FOUND = 'NOT_FOUND',
    CACHED = 'CACHED'
}

export interface OptionType {
    value: string;
    label: string;
}

export interface Master {
    gender_list: Record<string, string>;
    niche_list: Record<string, string>;
    age_group_list: string[],
    language_list: Record<string, string>
}

export interface Address {
    name: string,
    city: string,
    region: string,
    sublocality: string,
    pincode: string,
    premise: string,
    lat: number,
    lng: number,
    place_id?: string
}

export interface SavedAddress extends Address {
  id: string
  uuid: string
}